import { useSession } from '@/context/SessionProvider'
import { ButtonProps, Button, Flex } from '@chakra-ui/react'
import { useCallback } from 'react'
import { useTranslation } from 'next-i18next/pages'

export const WalletButton = ({ wrapperProps }: { wrapperProps?: ButtonProps }) => {
  const { t } = useTranslation()
  const { signIn } = useSession()

  const handleLogin = useCallback(async () => {
    signIn()
  }, [signIn])

  return (
    <Flex gap={2} alignItems={'center'}>
      <Button
        h={12}
        rounded={'2xl'}
        variant={'unstyled'}
        px={6}
        bg={'ninja.500'}
        color={'whiteAlpha.800'}
        _hover={{ bg: 'ninja.400', color: 'white' }}
        transition={'0.1s'}
        onClick={handleLogin}
      >
        {t('SignIn.login')}
      </Button>
      <Button {...wrapperProps} h={12} rounded={'2xl'} onClick={handleLogin}>
        {t('SignIn.register')}
      </Button>
    </Flex>
  )
}
